import { AuthContext } from "../context/AuthProvider";
import { useContext } from "react";

export const useAuthContext = () => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error ( "useAuthContext must be used within an AuthContextProvider")
    }

    return context;
}